import React from 'react';
import {
    BackButtonContainer,
    BackButtonIcon,
    BackText,
    Header,
    DesktopView,
    RegularText,
    ScrollViewStyle,
    BrandSpan,
    ImageDisplayWrapper,
    DetailsWrapper,       
} from './viewLargeImage.styled';
import {
    LARGE_TEXT_PX,
    SMALL_TEXT_PX,
    TITLE_FONT_COLOR,
    DARK_NAVY_FONT_COLOR
} from 'src/styles/fonts/MCFontConstants';
import BackIconBlue from 'src/assets/images/BaselineKeyboardArrowLeft24.svg';
import ImageDisplay from 'src/common/refactoredComponents/imageDisplay';
import { useTranslation } from 'react-i18next';

export default function ViewLargeImage({
    closeImageDisplay = () => {},
    images = {},
    isItemDetails = false,
}) {
    const { t } = useTranslation();

    return (
        <DesktopView>
            <Header>
                <BackButtonContainer>
                    <BackText fontSize={LARGE_TEXT_PX} fontWeight={'600'} color={DARK_NAVY_FONT_COLOR}>
                        {images.productImages?.length > 1
                            ? t('common.imagesFor')
                            : t('common.imageFor')}{' '}
                        {images.cfn || images.productCFN}
                    </BackText>
                </BackButtonContainer>
            </Header>
            <BackButtonContainer onClick={closeImageDisplay}>
                <BackButtonIcon src={BackIconBlue} />
                <BackText  fontSize={SMALL_TEXT_PX} fontWeight={'400'} color={TITLE_FONT_COLOR}>
                    {isItemDetails
                        ? t('common.backToItemDetails')
                        : t('common.backToSetDetails')}
                </BackText>
            </BackButtonContainer>
            <ScrollViewStyle>
                <ImageDisplayWrapper>
                    <ImageDisplay
                        images={images.productImages}
                        width={'500'}
                        height={'300'}
                        viewLarger={true}
                        showDots={images?.productImages?.length > 1}
                    />
                </ImageDisplayWrapper>
                <DetailsWrapper>
                    <RegularText>
                        {images.description}
                    </RegularText>
                    {images.brand && (
                        <RegularText small>
                            <BrandSpan>
                                {t('receiveSets.AutoListItem.Brand')}
                            </BrandSpan>{' '}
                            {images.brand}
                        </RegularText>
                    )}
                </DetailsWrapper>
            </ScrollViewStyle>
        </DesktopView>
    );
}